<template>
  <v-row justify="center">

    <!-- Modal de selección de productos -->
    <ProductosDialogCompra
      ref="productosDialog"
      @seleccionado="recibirProducto"
    ></ProductosDialogCompra>

    <v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text top right
    >
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog" persistent max-width="900" scrollable>
      <v-card>
        <v-card-title class="text-h5">
          Editar Compra
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>

              <!-- SECCIÓN: DATOS DEL COMPROBANTE -->
              <v-col cols="12">
                <v-sheet color="grey lighten-1" class="pa-3 mt-1">
                  <strong>DATOS DEL COMPROBANTE</strong>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="4">
                <v-text-field
                  v-model="compra.comprobante_numero"
                  label="N° Comprobante"
                  disabled outlined dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="4">
                <v-text-field
                  v-model="compra.fecha_registro"
                  label="Fecha de Registro"
                  disabled outlined dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="4">
                <v-text-field
                  v-model="compra.fecha_documento"
                  label="Fecha de Documento"
                  outlined dense
                  hint="Formato: YYYY-MM-DD"
                  persistent-hint
                  :rules="[v => !!v || 'Campo requerido', v => /^\d{4}-\d{2}-\d{2}$/.test(v) || 'Formato YYYY-MM-DD']"
                ></v-text-field>
              </v-col>

              <!-- SECCIÓN: INFORMACIÓN DE LA OPERACIÓN -->
              <v-col cols="12">
                <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>INFORMACIÓN DE LA OPERACIÓN</strong>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="6" lg="6">
                <v-sheet class="pa-3" elevation="0" outlined rounded>
                  <v-radio-group
                    v-model="compra.condicion"
                    row
                    label="Condición de Pago"
                    :rules="[v => !!v || 'Campo requerido']"
                  >
                    <v-radio label="CONTADO" value="CONTADO"></v-radio>
                    <v-radio label="CRÉDITO" value="CREDITO"></v-radio>
                  </v-radio-group>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="6" lg="6">
                <v-textarea
                  v-model="compra.obs"
                  label="Observaciones"
                  outlined dense rows="2" auto-grow
                ></v-textarea>
              </v-col>

              <!-- SECCIÓN: IMPORTES -->
              <v-col cols="12">
                <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>IMPORTES</strong>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  v-model.number="compra.total_excenta"
                  label="Total Exenta"
                  type="number" outlined dense
                  @input="recalcularTotales"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  v-model.number="compra.total_gravada5"
                  label="Gravada 5%"
                  type="number" outlined dense
                  @input="recalcularTotales"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  :value="ivaCalculado5"
                  label="IVA 5% (calculado)"
                  type="number" outlined dense disabled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  v-model.number="compra.total_gravada10"
                  label="Gravada 10%"
                  type="number" outlined dense
                  @input="recalcularTotales"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  :value="ivaCalculado10"
                  label="IVA 10% (calculado)"
                  type="number" outlined dense disabled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="3">
                <v-text-field
                  :value="montoTotalCalculado"
                  label="Monto Total"
                  type="number" outlined dense disabled
                ></v-text-field>
              </v-col>

              <!-- SECCIÓN: DETALLE DE PRODUCTOS -->
              <v-col cols="12">
                <v-sheet color="grey lighten-1" class="pa-3 mt-3">
                  <strong>DETALLE DE PRODUCTOS</strong>
                </v-sheet>
              </v-col>

              <!-- Fila para agregar detalle -->
              <v-col cols="12" sm="5" md="5" lg="5">
                <v-text-field
                  :value="detalleActual.producto ? detalleActual.producto.descripcion : ''"
                  label="Producto seleccionado"
                  outlined dense disabled
                  placeholder="Presione Buscar para seleccionar"
                >
                  <template v-slot:append>
                    <v-btn
                      small color="primary" class="mt-n1"
                      @click="$refs.productosDialog.openDialog()"
                    >
                      <v-icon small left>mdi-magnify</v-icon>
                      Buscar
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="2" md="2" lg="2">
                <v-text-field
                  v-model.number="detalleActual.cantidad"
                  label="Cantidad"
                  type="number" min="1" outlined dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3" lg="3">
                <v-text-field
                  v-model.number="detalleActual.precio_costo"
                  label="Precio Costo"
                  type="number" min="0" outlined dense
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="2" md="2" lg="2" class="d-flex align-center">
                <v-btn color="primary" outlined @click="agregarDetalle">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar
                </v-btn>
              </v-col>

              <!-- Tabla de detalles -->
              <v-col cols="12" v-if="detalles.length > 0">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Cantidad</th>
                        <th>Precio Costo</th>
                        <th>Subtotal</th>
                        <th>Quitar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(det, i) in detalles" :key="i">
                        <td>{{ det.producto ? det.producto.descripcion : '—' }}</td>
                        <td>{{ det.cantidad }}</td>
                        <td>{{ det.precio_costo }}</td>
                        <td>{{ det.cantidad * det.precio_costo }}</td>
                        <td>
                          <v-btn icon small color="red" @click="quitarDetalle(i)">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>

            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeDialog">Cancelar</v-btn>
          <v-btn color="success" @click="guardarCambios">Guardar Cambios</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import compraService from '@/services/compraService';
import ProductosDialogCompra from '@/components/tienda/compra/ProductosDialogCompra.vue';

export default {
  name: 'EditarCompraDialog',
  components: { ProductosDialogCompra },

  computed: {
    ivaCalculado5() {
      return Math.round((this.compra.total_gravada5 || 0) / 11);
    },
    ivaCalculado10() {
      return Math.round((this.compra.total_gravada10 || 0) / 11);
    },
    montoTotalCalculado() {
      return (
        parseFloat(this.compra.total_excenta || 0) +
        parseFloat(this.compra.total_gravada5 || 0) +
        parseFloat(this.compra.total_gravada10 || 0)
      );
    }
  },

  data() {
    return {
      dialog: false,
      valid: true,
      compra: {
        id: null,
        comprobante_numero: '',
        fecha_registro: '',
        fecha_documento: '',
        condicion: 'CONTADO',
        total_excenta: 0,
        total_gravada5: 0,
        total_iva5: 0,
        total_gravada10: 0,
        total_iva10: 0,
        monto_total: 0,
        obs: ''
      },
      detalles: [],
      detalleActual: {
        producto: null,
        cantidad: 1,
        precio_costo: 0
      },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        timeout: 5000,
        colorBtn: 'white'
      }
    };
  },

  methods: {

    openDialog(compra) {
      // Clonar campos de la compra
      this.compra = {
        id:                  compra.id,
        comprobante_numero:  compra.comprobante_numero,
        fecha_registro:      compra.fecha_registro,
        fecha_documento:     compra.fecha_documento,
        condicion:           compra.condicion,
        total_excenta:       parseFloat(compra.total_excenta  || 0),
        total_gravada5:      parseFloat(compra.total_gravada5 || 0),
        total_iva5:          parseFloat(compra.total_iva5     || 0),
        total_gravada10:     parseFloat(compra.total_gravada10|| 0),
        total_iva10:         parseFloat(compra.total_iva10    || 0),
        monto_total:         parseFloat(compra.monto_total    || 0),
        obs:                 compra.obs || ''
      };

      // Mapear detalles existentes al formato del componente
      this.detalles = (compra.detalle_compras || []).map(d => ({
        producto:     d.producto,
        cantidad:     parseFloat(d.cantidad),
        precio_costo: parseFloat(d.precio_costo)
      }));

      this.detalleActual = { producto: null, cantidad: 1, precio_costo: 0 };
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.$refs.form?.resetValidation();
    },

    recalcularTotales() {
      this.compra.total_iva5   = this.ivaCalculado5;
      this.compra.total_iva10  = this.ivaCalculado10;
      this.compra.monto_total  = this.montoTotalCalculado;
    },

    agregarDetalle() {
      if (!this.detalleActual.producto) {
        this.mensajeError('Debe seleccionar un producto');
        return;
      }
      if (this.detalleActual.cantidad <= 0) {
        this.mensajeError('La cantidad debe ser mayor a 0');
        return;
      }
      this.detalles.push({ ...this.detalleActual });

      // Recalcular gravada 10 sumando subtotales de todos los detalles
      this.compra.total_gravada10 = this.detalles.reduce((acc, d) => {
        return acc + (d.cantidad * d.precio_costo);
      }, 0);

      this.recalcularTotales();
      this.detalleActual = { producto: null, cantidad: 1, precio_costo: 0 };
    },

    quitarDetalle(index) {
      this.detalles.splice(index, 1);

      this.compra.total_gravada10 = this.detalles.reduce((acc, d) => {
        return acc + (d.cantidad * d.precio_costo);
      }, 0);

      this.recalcularTotales();
    },

    recibirProducto(producto) {
      this.detalleActual.producto = producto;
      if (producto.pcu && parseFloat(producto.pcu) > 0) {
        this.detalleActual.precio_costo = parseFloat(producto.pcu);
      }
    },

    async guardarCambios() {
      if (!this.$refs.form.validate()) return;

      this.recalcularTotales();

      const payload = {
        compra: {
          condicion:        this.compra.condicion,
          fecha_documento:  this.compra.fecha_documento,
          total_excenta:    this.compra.total_excenta,
          total_gravada5:   this.compra.total_gravada5,
          total_iva5:       this.ivaCalculado5,
          total_gravada10:  this.compra.total_gravada10,
          total_iva10:      this.ivaCalculado10,
          monto_total:      this.montoTotalCalculado,
          obs:              this.compra.obs
        },
        detalles: this.detalles.map(d => ({
          producto_id:         d.producto.id,
          cantidad:            d.cantidad,
          precio_costo:        d.precio_costo,
          precio_costo_total:  d.cantidad * d.precio_costo
        }))
      };

      try {
        await compraService.update(this.compra.id, payload);
        this.$emit('actualizado');
        this.closeDialog();
      } catch (error) {
        const msg = error.response?.data?.message || 'Error al guardar los cambios';
        this.mensajeError(msg);
      }
    },

    mensajeOk(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'success', timeout: 5000, colorBtn: 'white' };
    },

    mensajeError(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'error', timeout: 5000, colorBtn: 'white' };
    }
  }
};
</script>
